import { Badge, IconButton, Tooltip } from "@mui/material";
import ContactMailIcon from "@mui/icons-material/ContactMail";
import { useTranslation } from "react-i18next";

import { ContactBlock } from "../../util/Batch";
import { contactSummary, hasContact } from "./contactBlock";

interface Props {
	contact?: ContactBlock | null;
	onClick: () => void;
	disabled?: boolean;
}

/**
 * Sits beside the refresh icon in the client field's label. Filled when the
 * document carries a contact block, outlined when it does not.
 */
const AddressLineButton = ({ contact, onClick, disabled }: Props) => {
	const { t } = useTranslation();
	const filled = hasContact(contact);
	const tooltip = filled
		? t("common:addressLine.edit", { contact: contactSummary(contact) })
		: t("common:addressLine.add");

	return (
		<Tooltip title={tooltip} arrow>
			<span>
				<IconButton
					onClick={onClick}
					disabled={disabled}
					aria-label={tooltip}
					tabIndex={-1}
					size="small"
					sx={{
						color: filled ? "#1E88E5" : "#90A4AE",
						"&:hover": { bgcolor: "rgba(30, 136, 229, 0.1)" },
					}}
				>
					<Badge color="primary" variant="dot" invisible={!filled} overlap="circular">
						<ContactMailIcon fontSize="small" />
					</Badge>
				</IconButton>
			</span>
		</Tooltip>
	);
};

export default AddressLineButton;
